// FooterContainer.js
import React from 'react';
import { useIntl } from 'react-intl';
import { ExternalLink, LinkedLogo, NamedLink } from '../../components';
import { categoryValue } from '../../util/categories';

import css from './FooterContainer.module.css';
import Icons from '../../components/Icons/Icons';

function FooterContainer(props) {
  const intl = useIntl();

  // ✅ Must match SectionShopByCategory categories (pub_categoryLevel1 values)
  const productCategories = [
    {
      key: 'technicalSuits',
      label: intl.formatMessage({ id: 'FooterContainer.productCategories.technicalSuits' }),
    },
    {
      key: 'trainingSuits',
      label: intl.formatMessage({ id: 'FooterContainer.productCategories.trainingSuits' }),
    },
    {
      key: 'swimCaps',
      label: intl.formatMessage({ id: 'FooterContainer.productCategories.swimCaps' }),
    },
    {
      key: 'goggles',
      label: intl.formatMessage({ id: 'FooterContainer.productCategories.goggles' }),
    },
    {
      key: 'trainingGear',
      label: intl.formatMessage({ id: 'FooterContainer.productCategories.trainingGear' }),
    },
    {
      key: 'techAndWearables',
      label: intl.formatMessage({ id: 'FooterContainer.productCategories.techAndWearables' }),
    },
    {
      key: 'bagsAndBackpacks',
      label: intl.formatMessage({ id: 'FooterContainer.productCategories.bagsAndBackpacks' }),
    },
    {
      key: 'clothing',
      label: intl.formatMessage({ id: 'FooterContainer.productCategories.clothing' }),
    },
    {
      key: 'accessories',
      label: intl.formatMessage({ id: 'FooterContainer.productCategories.accessories' }),
    },
    {
      key: 'other',
      label: intl.formatMessage({ id: 'FooterContainer.productCategories.other' }),
    },
  ];

  const quickCmsPageLinks = [
    {
      pageId: 'about',
      label: intl.formatMessage({ id: 'FooterContainer.cmsPages.about' }),
    },
    {
      pageId: 'buyer_protection',
      label: intl.formatMessage({ id: 'FooterContainer.cmsPages.buyerProtection' }),
    },
    {
      pageId: 'fees',
      label: intl.formatMessage({ id: 'FooterContainer.cmsPages.fees' }),
    },
    {
      pageId: 'returns_resolutions',
      label: intl.formatMessage({ id: 'FooterContainer.cmsPages.refundsAndResolutions' }),
    },
    {
      pageId: 'seller_checklist',
      label: intl.formatMessage({ id: 'FooterContainer.cmsPages.sellerChecklist' }),
    },
  ];

  const legalCmsPageLinks = [
    {
      pageId: 'privacy-policy',
      label: intl.formatMessage({ id: 'FooterContainer.legal.privacyPolicy' }),
    },
    {
      pageId: 'terms-of-service',
      label: intl.formatMessage({ id: 'FooterContainer.legal.termsOfService' }),
    },
  ];

  return (
    <div className={css.footer}>
      <div className={css.footerTop}>
        <div className={css.contentWidth}>
          <div className={css.leftBlock}>
            <div className={css.linksBlock}>
              <LinkedLogo className={css.logo} />
              <p>{intl.formatMessage({ id: 'FooterContainer.tagline' })}</p>
            </div>
          </div>

          <div className={css.rightBlock}>
            <div className={css.linksBlock}>
              <h2>{intl.formatMessage({ id: 'FooterContainer.productCategories.title' })}</h2>

              {productCategories.map(category => (
                <NamedLink
                  key={category.key}
                  name="SearchPage"
                  to={{ search: `?pub_categoryLevel1=${categoryValue(category.key)}` }}
                  className={css.link}
                >
                  {category.label}
                </NamedLink>
              ))}
            </div>

            <div className={css.linksBlock}>
              <h2>{intl.formatMessage({ id: 'FooterContainer.quickLinks.title' })}</h2>

              <NamedLink name="SearchPage" className={css.link}>
                {intl.formatMessage({ id: 'FooterContainer.quickLinks.buyNow' })}
              </NamedLink>

              <NamedLink name="NewListingPage" className={css.link}>
                {intl.formatMessage({ id: 'FooterContainer.quickLinks.sellNow' })}
              </NamedLink>

              <NamedLink name="LoginPage" className={css.link}>
                {intl.formatMessage({ id: 'FooterContainer.quickLinks.login' })}
              </NamedLink>

              <NamedLink name="SearchPage" className={css.link}>
                {intl.formatMessage({ id: 'FooterContainer.quickLinks.search' })}
              </NamedLink>

              {quickCmsPageLinks.map(link => (
                <NamedLink
                  key={link.pageId}
                  name="CMSPage"
                  params={{ pageId: link.pageId }}
                  className={css.link}
                >
                  {link.label}
                </NamedLink>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={css.footerBottom}>
        <div className={css.contentWidth}>
          <div className={css.footerBottomLeft}>
            <p>{intl.formatMessage({ id: 'Footer.FooterText' })}</p>

            {legalCmsPageLinks.map(link => (
              <NamedLink
                key={link.pageId}
                name="CMSPage"
                params={{ pageId: link.pageId }}
                className={css.link}
              >
                {link.label}
              </NamedLink>
            ))}
          </div>

          <div className={css.footerBottomRight}>
            <ExternalLink
              href="https://www.facebook.com"
              className={css.link}
              aria-label="Facebook"
            >
              <Icons name="facebook" />
            </ExternalLink>

            <ExternalLink
              href="https://www.instagram.com"
              className={css.link}
              aria-label="Instagram"
            >
              <Icons name="instagram" />
            </ExternalLink>

            <ExternalLink
              href="https://www.linkedin.com"
              className={css.link}
              aria-label="LinkedIn"
            >
              <Icons name="linkedin" />
            </ExternalLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterContainer;
